module.exports = __webpack_public_path__ + "static/media/difdisplay-webfont.3a94dfe4.woff";